export const DEFAULT_SELECTED_SUBPUBLISHER_CATALOG = {
  id: 'vtex-ads-network',
  label: 'VTEX Ads Network'
}
